<template>
  <v-card>
    <v-card-title>{{ title }} items</v-card-title>
    <v-progress-linear
      indeterminate
      color="primary"
      height="4"
      v-if="isLoading"
    />
    <v-row v-if="isLoading || !categoriesList.length">
      <v-col cols="12">
        <p class="body-1 text-center pb-0 pt-4">
          {{ isLoading ? 'Loading...' : 'No data available' }}
        </p>
      </v-col>
    </v-row>
    <v-divider />
    <v-card :key="category" v-for="category of categoriesList">
      <MigrationSummaryItemsTable
        :title="CategoriesLabelsMap[category]"
        :columns="columns"
        :rows="rowsByCategoriesMap[category]"
      />
    </v-card>
  </v-card>
</template>

<script>
import { migrationApiV1 } from '@/api/v1';
import { migrationApiV2 } from '@/api/v2';
import { CategoriesLabelsMap } from '@/constants';
import MigrationSummaryItemsTable from '@/components/dialogs/MigrationSummary/MigrationSummaryItemsTable';

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    filter: {
      type: Object,
      default: () => ({})
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  components: {
    MigrationSummaryItemsTable
  },
  mounted() {
    this.fetchRows();
  },
  data() {
    return {
      CategoriesLabelsMap,
      isLoading: false,
      rowsByCategoriesMap: null,
      categoriesList: []
    };
  },
  methods: {
    async fetchRows() {
      this.isLoading = true;
      const resultId = this.$route.params.result_id;

      this.rowsByCategoriesMap = await (
        this.$store.getters.isMatcherApiV2Enabled
          ? migrationApiV2
          : migrationApiV1
      ).fetchMigrationResultRows(resultId, this.filter);
      this.categoriesList = Object.keys(this.rowsByCategoriesMap);
      this.isLoading = false;
    }
  }
};
</script>
